const { id, log } = require("../std/index")


// Meta

const allWidgets = {};

const widgetId = (() => {
  let i = 0;
  return () => 'x' + i++;
})();


// Widgets Library

const Widgets = {
  'tooltip': require('./tooltip'),
  'lightbox': require('./lightbox'),
  'fading-bg': require('./fading-bg'),
  'live-price': require('./live-price'),
  'coupon-code': require('./coupon-code'),
  'fancy-title': require('./fancy-title'),
  'mobile-video': require('./mobile-video'),
  'gallery-swapper': require('./gallery-swapper'),
  'gallery-controls': require('./casings-diagram-controls'),
  'background-video': require('./background-video'),
  'currency-chooser': require('./currency-chooser'),
  'locality-chooser': require('./locality-chooser'),
  'accordian-swapper': require('./accordian-swapper'),
  'sausage-calculator': require('./sausage-calculator'),
  'invisible-checkbox': require('./invisible-checkbox'),
  'homepage-slideshow': require('./homepage-slideshow'),
  'sliding-shop-links': require('./sliding-shop-links'),
  'location-dropdown': require('./location-dropdown'),
  'cart-quantity': require('./cart-quantity')
};


// Functions

const findWidgetInstances = ($region, type) => {
  const $widgets = $(`[data-widget="${type}"]`, $region);
  return $widgets.toArray().map(getInstanceFrom);
};

const getInstanceFrom = (target) => {
  const $target = $(target);
  const data = $target.data();

  // Error gauntlet
  if ($target.length < 1) {
    return log("Tried to get widget instance of empty selection:", $target.selector);
  }

  if (!data.widgetId) {
    return log("Element has no widget instance ID:", $target[0]);
  }

  if (!allWidgets[data.widgetId]) {
    return log(`Tried to get widget instance ${data.widgetId} from`, $target[0], "but couldn't find it.");
  }

  // Finally, everything works
  return allWidgets[data.widgetId];
};

const initWidget = (ix, target) => {
  const $this = $(target);
  const config = $this.data();
  const type = config.widget;

  if (type && Widgets[type]) {
    const newId = widgetId();
    config.widgetId = newId;
    $this.data('widget-id', newId);
    allWidgets[newId] = new Widgets[type]($this, config);
  } else {
    console?.warn('Unknown widget:', type);
  }
};

module.exports = {
  findWidgetInstances,
  getInstanceFrom,
  initWidget
};
